import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, bytesToSize} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import Genres from '../components/genres/genres';

//import AudioPlayer from '../components/audio/audio';
import DJAreaSideMenu from './sidemenu';

import moment from 'moment';
import momenttz from 'moment-timezone';
import Calendar from 'react-calendar';

//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import '../components/fontawesome/fontawesome';

import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';

var newday = -1;
function ScheduleDate({schedule}) {
	const x = new Date(schedule.start*1000);
	if( x.getDay() !== newday ) {
		newday = x.getDay();
		return (
			<div className="col-12 mt-3">
				<div className="p-schedule-event-add">
					<div className="p-schedule-day p-2">
						{moment(schedule.start*1000).format("dddd Do MMMM")}
					</div>
				</div>
			</div>
		)
	} else return <></>;
}

export default class AdminPreviousSets extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			date: new Date(),
			schedule: {},
			rtmp: [],
			empty: [],
			custom: [],
		};
		this.loadPrevious = this.loadPrevious.bind(this);
		this.setDate = this.setDate.bind(this);
		this.playVideo = this.playVideo.bind(this);
		this.editChanges = this.editChanges.bind(this);
		this.saveChanges = this.saveChanges.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Admin Previous Sets - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		await this.loadPrevious();
	}

	componentWillUnmount() {
	}

	async loadPrevious() {
		let d = new Date(this.state.date);
			d.setHours(0);
			d.setMinutes(0);
			d.setSeconds(0);
		let params = new URLSearchParams();
		params.append('channel', 'clubbers');
		params.append('schedule', Math.floor(d.getTime()/1000));
		const x = await postApi('/api/v2/admin/previous', params);

		let empty = [];
		for( let i in x.data.rtmp) {
			if( x.data.rtmp[i].schedule === 0 )
			empty.push(x.data.rtmp[i]);
		}
		console.log(empty);

		console.log(x.data);
		this.setState({schedule: x.data.schedule, rtmp: x.data.rtmp, empty});
		//this.setState({publish: x.data.publish, published: x.data.published});
	}

	setDate(e) {
		this.setState({date: e}, ()=>this.loadPrevious());
	}

	async playVideo(name) {
		let filename = name;
		filename = filename.substring(7,filename.length);
		console.log(name, filename);
		window.open(`https://cloud.mix365.co.uk:4433${filename}`, "_blank", "noreferrer");
	}

	async editChanges(filename, schedule) {
		console.log(filename, schedule);
		let rtmp = this.state.rtmp;
		for( let i in rtmp ) {
			
			if( rtmp[i].filename === filename ) {
				rtmp[i].schedule = schedule;
				rtmp[i].changes = true;
				console.log(rtmp[i]);
				
			}
		}
		this.setState({rtmp});
	}
	
	async saveChanges() {
		let rtmp = this.state.rtmp;
		let params = new URLSearchParams();
		for( let i in rtmp ) {
			if( rtmp[i].changes ) {
				params.append( `change${i}`, JSON.stringify({ filename: rtmp[i].filename, ctime: rtmp[i].ctime, schedule: rtmp[i].schedule }));
			}
		}
		await putApi('/api/v2/admin/previous', params);
		await this.loadPrevious();
	}

	render() {
		const user = this.context;
		newday = 0;
		//let uk_time = user.user.user?.timezone;
		let _date = Math.floor(Date.now()/1000);
		
		let timezone_non = new Date().getTimezoneOffset()*-1;//.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
		let timezone_uk = momenttz(timezone_non).tz("Europe/London")._offset;
		console.log( timezone_non, timezone_uk );

		const schedule = 
      Object.keys(this.state.schedule).map((e,i) => {
        return (
					<React.Fragment key={i}>
						<ScheduleDate schedule={this.state.schedule[e]} />
						<div className="col-12" /*onMouseEnter={()=>this.schedulehover(e)} onMouseLeave={()=>this.schedulehover(0)}*/>
							<div className={`p-schedule-event ${this.state.schedule[e].cancelled===1&&this.state.schedule[e].dummy===0?'p-schedule-event-cancelled':''}`}>
								<Row className="gx-0">
									<Col xs={12} md={2} className="p-schedule-event-header text-vcenter">
										<div>
											{moment(this.state.schedule[e].start*1000).format("HH:mm - ")}
											{moment(this.state.schedule[e].end*1000).format("HH:mm")}<br />
											{this.state.schedule[e].channel}

											
										</div>
									</Col>
									<div className="p-schedule-event-image">
										<img src={`https://mix365.co.uk/${this.state.schedule[e].avatar}`} width="84" height="84" alt="profile avatar" />
									</div>
									<Col className="p-schedule-event-right text-vertical">
										<div>
											<Link to={this.state.schedule[e].username===null?'#':`/${this.state.schedule[e].username.replaceAll(' ','_')}`} className="pb-4">
												{this.state.schedule[e].djtitle?this.state.schedule[e].djtitle:this.state.schedule[e].title?this.state.schedule[e].title:this.state.schedule[e].username}
											</Link>{this.state.schedule[e].cancelled===1 && this.state.schedule[e].dummy===0 && <>&nbsp;&nbsp;Cancelled</>}<br />
											{this.state.schedule[e].description && <><span className="p-schedule-description">{this.state.schedule[e].description}</span><br /></>}
											{user.user?.admin?.admin_access && this.state.schedule[e]?.syndicate &&<><span className="p-schedule-syndicate">Syndicate: {this.state.schedule[e]?.syndicate}</span></>}
											<Genres genres={ this.state.schedule[e].genres.length > 0 ? this.state.schedule[e].genres : this.state.schedule[e].start>_date ? this.state.schedule[e].defaultgenres : [] } />
										</div>
									</Col>
									<Col xs={12} md={4} className="p-schedule-event-bottom text-vcenter">
										<div>
											{user.user.user.id===3&&<><small>schedule: {this.state.schedule[e].id}, uid: {this.state.schedule[e].uid}&nbsp;&nbsp;</small><br/></>}
											
												
												{this.state.rtmp.filter((x => x.schedule === this.state.schedule[e].id)).map(schedule => {
													let file = schedule.filename.substring(schedule.filename.lastIndexOf("/")+1);
													return (
														<React.Fragment key={schedule.schedule}>
															<ButtonGroup size="sm">
																<Button size="sm" onClick={()=>this.playVideo(schedule.filename)}>
																	{file} {bytesToSize(schedule.size)}
																</Button><br />
																<Button size="sm" onClick={()=>this.editChanges(schedule.filename, 0)}>X</Button>
															</ButtonGroup><br />
														</React.Fragment>
												)})}
												<Form.Control size="sm" as="select" style={{border: '1px solid var(--main-primary-color) !important', paddingY: '0.25rem', paddingX: '0.5rem', fontSize: '0.875rem', borderRadius: '0.25rem', backgroundColor: '#1c1c1c !important'}}>
													<option>Select to add</option>
													{Object.keys(this.state.empty).map((f,j) => {
														let file = this.state.empty[f].filename.substring(this.state.empty[f].filename.lastIndexOf("/")+1);
														return (
															<option key={j} onClick={()=>this.editChanges(this.state.empty[f].filename, this.state.schedule[e].id)}>{file} {bytesToSize(this.state.empty[f].size)}</option>
														)
													})}
												</Form.Control>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</React.Fragment>
        )
      })
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>
					<Row>

						<div className="col">


							<div className="row text-white admin-panel">
								<div className="col-12 admin-panel-header">
									
								</div>
								<div className="col-12 admin-panel-body">
									<Calendar onChange={this.setDate} value={this.state.date} maxDetail="month" next2Label='' prev2Label='' />
									<Button size="sm" onClick={this.saveChanges}>Save Changes</Button>
								</div>
							</div>


							<div className="row mt-5 text-white admin-panel">
								<div className="col-12 admin-panel-header">
									
								</div>
								<div className="col-12 admin-panel-body">
									{schedule}
								</div>
							</div>

						</div>
					</Row>
				</Col>
			</Row>
		);
	}
}
